import imgSvg from '/images/img1.svg';
import yourKits from '/images/yourkits.svg';
import ewd from '/images/ewd.png';
import lps from '/images/lps.png';
import ap from '/images/annualReport.png';
import pd from '/images/pd.png';
import fnc from '/images/fnc.png';
import wv from '/images/wv.png';
import prx from '/images/prx.png';
import npx from '/images/npx.png';
import cc from '/images/cc.png';
import oc from '/images/oc.png';
import { TwContainer } from '~/lib/TwContainer';
import { Card, Image } from '@mantine/core';

export const SectionOne = () => {
	return (
		<>
			<section
				className="bg-dark relative"
				style={{ transition: 'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s' }}>
				<div className="background-overlay"></div>
				<TwContainer className="pt-28 px-8 z-10 relative">
					<div className={'grid md:grid-cols-2 grid-cols-1 gap-x-24 pb-60'}>
						<div className={'my-auto flex-col flex gap-4'}>
							<h1 className="text-base font-medium font-saira max-w-xl text-emerald-300">START YOUR DIGITAL BUSINESS</h1>
							<h1 className="text-5xl font-semibold font-beVietnamPro max-w-xl text-white mt-0">Delivering Beyond Expectation</h1>
							<h1 className="font-semibold font-inter max-w-lg text-lg text-white mt-0">
								We combine strategy with design & technology to craft solutions that ensure customers prefer you over your competitors.
							</h1>
						</div>
						<Image
							alt={''}
							src={imgSvg}
						/>
					</div>
				</TwContainer>
			</section>
			<section className="bg-white py-48 relative">
				<div className={'absolute bottom-[20px]  md:w-full w-fit bg-transparent'}>
					<Card className={'bg-secondary mx-auto md:px-16 md:py-12 p-8 max-w-[1400px]'}>
						<h1 className={'text-white text-center md:text-4xl text-xl font-saira'}>Join our 100+ happy customers</h1>
						<div className={'flex md:gap-16 pt-12 flex-wrap justify-around'}>
							<div className={'flex'}>
								<strong className={'text-white font-sourceSerifPro md:text-5xl text-xl md:leading-relaxed leading-normal'}>your</strong>
								<img
									className={'md:max-h-16 max-h-10'}
									alt={''}
									src={yourKits}
								/>
							</div>
							<div className={'flex'}>
								<img
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={npx}
								/>
							</div>

							<div className={'flex'}>
								<img
									style={{ filter: 'brightness(0) invert(1)' }}
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={lps}
								/>
							</div>
							<div className={'flex'}>
								<img
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={ap}
								/>
							</div>
							<div className={'flex'}>
								<img
									style={{ filter: 'brightness(0) invert(1)' }}
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={ewd}
								/>
							</div>
							<div className={'flex'}>
								<img
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={pd}
								/>
							</div>
							<div className={'flex'}>
								<img
									style={{ filter: 'brightness(0) invert(1)' }}
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={fnc}
								/>
							</div>
							<div className={'flex'}>
								<img
									style={{ filter: 'brightness(0) invert(1)' }}
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={'/images/boir.png'}
								/>
							</div>
							<div className={'flex'}>
								<img
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={prx}
								/>
							</div>
							<div className={'flex'}>
								<img
									style={{ filter: 'brightness(0) invert(1)' }}
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={wv}
								/>
							</div>

							<div className={'flex'}>
								<img
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={cc}
								/>
							</div>
							<div className={'flex'}>
								<img
									style={{ filter: 'brightness(0) invert(1)' }}
									className={'md:max-h-16 max-h-6'}
									alt={''}
									src={oc}
								/>
							</div>
						</div>
					</Card>
				</div>
			</section>
		</>
	);
};
